import './PreventiveIssueDetailsModal.scss';

import { usePreventiveIssueClose } from "../../../../../hooks/usePreventiveIssueClose";

import { Field } from "../../../../../common-components/Field/Field";
import { Button } from "../../../../../common-components/Buttons/Buttons";

const PreventiveIssueDetailsModal = ({id}) => {
    const { formId, handleSend } = usePreventiveIssueClose({id})

    return (
        <div className={"preventive-issue-details-modal"}>
            <div className={"preventive-issue-details-modal_container"}>
                <div className={"preventive-issue-details-modal_title"}>
                    {"Закрытие нарушения"}
                </div>
                <div className={"preventive-issue-details-modal_field"}>
                    <Field
                        label={"Дата устранения"}
                        name={"elimination_completion_date"}
                        formId={formId}
                        type={"date"}
                        validationRules={{required: true}}
                    />
                </div>
                <div className={"preventive-issue-details-modal_button"}>
                    <Button title={"Закрыть нарушение"} onClick={handleSend}/>
                </div>
            </div>
        </div>
    )
}

export default PreventiveIssueDetailsModal;